// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc73345d","455":"cdb2958e","977":"e419fe93"}[chunkId] + ".chunk.js";
};